import {
  createBlock,
  flattenBlocks,
  cleanupEmptyContainers,
  ensureCalloutsHaveChildren,
  ensureChoicesHavePaths,
  removeBlockFromTree,
  updateBlockInTree,
} from '../../../utils/blockUtils';
import { indentOf, MAX_INDENT, rememberIndent } from '../../../utils/indentUtils';
import { focusEditable } from '../../../utils/focusUtils';
import { EDITABLE_TYPES } from '../../../utils/editorConstants';

const INDENTABLE_TYPES = ['text', 'bullet', 'number', 'checkbox', 'callout', 'choice'];

/** Remove `ids`, then keep at least one editable field in the tree. */
export function removeBlocksKeepingEditable(tree, ids) {
  let next = tree;
  ids.forEach((id) => {
    next = removeBlockFromTree(next, id);
  });
  next = ensureChoicesHavePaths(ensureCalloutsHaveChildren(cleanupEmptyContainers(next)));
  if (!flattenBlocks(next).some((b) => EDITABLE_TYPES.includes(b.type))) {
    const fresh = createBlock('text');
    next = [...next, fresh];
    focusEditable(fresh.id);
  }
  return next;
}

/**
 * Tab / Shift+Tab on handle-selected blocks.
 * `handled` is true when any indentable target exists (caller should
 * preventDefault even if indent was already at the min/max).
 */
export function indentSelectedBlocks(tree, targets, delta) {
  const indentable = targets.filter((b) => INDENTABLE_TYPES.includes(b.type));
  if (!indentable.length) return { handled: false, next: tree, changed: false };
  let next = tree;
  let changed = false;
  indentable.forEach((b) => {
    const current = indentOf(b);
    const nextIndent = Math.max(0, Math.min(MAX_INDENT, current + delta));
    if (nextIndent === current) return;
    changed = true;
    rememberIndent(b.id, nextIndent);
    next = updateBlockInTree(next, b.id, {
      props: { ...b.props, indent: nextIndent },
    });
  });
  return { handled: true, next, changed };
}
